import { VStack, Text } from '@cad-arc';
import { differenceInDays, differenceInHours, differenceInMinutes } from 'date-fns';
import { UnitStatusSearchRow } from '@mark43/cad-api';
import { formatMonthDayYear, formatShortTime, naivePluralize } from '../common/helpers/utils';
import { ExpandableContent } from './expandable-content';

export function UnitStatusSearchResultsDateCell({
    row,
    isExpanded,
}: {
    row: UnitStatusSearchRow;
    isExpanded: boolean;
}) {
    return (
        <VStack align="left">
            <Text style={{ whiteSpace: 'pre-line' }}>
                {formatDateRange(row.startDate, row.endDate)}
            </Text>
            <ExpandableContent isExpanded={isExpanded}>
                <Text>{formatTotalDuration(row.startDate, row.endDate)}</Text>
            </ExpandableContent>
        </VStack>
    );
}

export function formatDateRange(startDate: string, endDate?: string) {
    const formattedStartDate = formatMonthDayYear(startDate);
    const formattedStartTime = formatShortTime(startDate);
    const formattedEndTime = endDate ? formatShortTime(endDate) : undefined;
    const formattedTimeRange = formattedEndTime
        ? `${formattedStartTime} - ${formattedEndTime}`
        : formattedStartTime;
    const days = endDate ? differenceInDays(new Date(endDate), new Date(startDate)) : undefined;
    return `${formattedStartDate}\n${formattedTimeRange}${days ? ` +${days}` : ''}`;
}

export function formatTotalDuration(startDate: string, endDate?: string) {
    const now = new Date();
    const effectiveEndDate = endDate ? new Date(endDate) : now;
    const hours = differenceInHours(effectiveEndDate, new Date(startDate));
    const minutes = differenceInMinutes(effectiveEndDate, new Date(startDate)) % 60;
    return `${hours ? `${hours} ${naivePluralize('hr', hours)}. ` : ''}${minutes} min.`;
}
